<script setup lang="ts">
import FormCategoriaProduto from '../components/form-categoriaproduto.vue'
import { useCategoriaProdutoStore } from '../store/useCategoriaProdutoStore'

definePage({
  meta: {
    navActiveLink: 'admin-categoria-produto',
    action: 'edit',
    subject: 'categoria-produto',
  },
})

const store = useCategoriaProdutoStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormCategoriaProduto is-editing />
</template>
